import React from "react";
import useSelect from "../hooks/useSelect";
import ResultComponent from "./ResultComponent";
import { CloseIcon, Container, Question, Wrapper } from "./styled";
import 이동휘이미지 from "../assets/이동휘-독립운동가.jpeg";
import styled from "styled-components";

interface Props {
  setScreen: React.Dispatch<React.SetStateAction<string>>;
}

const Stage7 = ({ setScreen }: Props) => {
  const ANSWER = 1; // 이동휘 - 독립운동가
  const { select, onClickItem } = useSelect(ANSWER);

  return (
    <Container>
      <Question>
        이 인물은 독립운동가일까요
        <br />
        친일파일까요?
      </Question>

      <AnswerContainer>
        <Image src={이동휘이미지} alt="이동휘" />

        <Wrapper onClick={() => onClickItem(1)} $correct={!!select}>
          <Text>⓵ 독립운동가</Text>
          {select === 1 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(2)} $incorrect={select === 2}>
          <Text>⓶ 친일파</Text>
          {select === 2 && <CloseIcon />}
        </Wrapper>
      </AnswerContainer>

      {!!select && (
        <ResultComponent
          select={select}
          answer={ANSWER}
          nextStage="result"
          setScreen={setScreen}
          desc={
            <Desc>
              <strong>이동휘</strong>
              <br />
              이동휘(李東輝, 1873년 6월 20일 ~ 1935년 1월 31일)는 대한제국의
              군인, 정치가이자 일제강점기의 사회주의 계열 독립운동가이다.[2]
              대한제국기 육군 장교 출신으로 한말 애국계몽운동과 의병 운동을
              이끌었고 함경도, 평안도, 북간도, 연해주 한인 사회 등에서
              활동하면서 기독교인으로 기독교 사상을 전파하는 독실한 전도사로
              활동하기도 했다. 1919년 대한민국임시정부의 국무총리를 역임하기도
              했다. 아호(雅號)는 성재(誠齋)이며 대자유(大自由)라는 호(號)를
              사용하기도 했다.
            </Desc>
          }
        />
      )}
    </Container>
  );
};

export default Stage7;

const Image = styled.img`
  width: 280px;
`;

const AnswerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;

  margin-top: 20px;
`;

const Text = styled.div`
  font-size: 30px;
`;

const Desc = styled.div`
  font-size: 20px;

  & strong {
    font-size: 30px;
  }
`;
